import { type ReactNode } from "react";

/** One hierarchy for catalogues, details and forms; actions wrap below on narrow screens. */
export function PageHeader({ title, subtitle, kicker, actions, className = "" }: {
  title: ReactNode;
  subtitle?: ReactNode;
  kicker?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return <header className={`app-page-header ${className}`}>
    <div className="app-page-header-copy editor-header-copy">
      {kicker ? <p className="section-kicker">{kicker}</p> : null}
      <h1>{title}</h1>
      {subtitle ? <p className="app-page-subtitle">{subtitle}</p> : null}
    </div>
    {actions ? <div className="app-page-header-actions editor-header-actions">{actions}</div> : null}
  </header>;
}
